import templateUrl from './product-label-preview.html';

export default {
  templateUrl,
  bindings: {
    product: '<'
  },
  controller: class ProductLabelDownloadComponent {
    constructor($log, ameLightbox, ProductsService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $log,
        ameLightbox,
        ProductsService,
        ToastService
      });
    }

    $onInit() {
      if (this.product.hasPDFLabel) {
        this.ProductsService.getLabel(this.product.ProductId).then((r) => {
          this.label = r.data;
        }).catch(() => {
          this.$log.error(`Unable to get product label PDF download link! Product ID: ${this.product.ProductId})`);
        });
      } else {
        this.ProductsService.getLabelThumbnail(this.product.ProductId).then((r) => {
          this.imageArr = r.data;
        }).catch(() => {
          this.$log.error(`Unable to get product label thumbnail! Product ID: ${this.product.ProductId})`);
        });
      }
    }

    previewLabelImage(productId) {
      this.ProductsService.getLabelImage(productId)
        .then((r) => {
          this.ameLightbox.show([r.data], {
            buttonClass: 'ng-hide',
            keyboard: false,
            showDots: false
          });
        }).catch(error => this.ToastService.showError(error));
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/products/product-label-preview/product-label-preview.component.js